import React from 'react';
import { Handle, Position } from 'reactflow';
import { 
  Box,
  Typography
} from '@mui/material';

export const RandomNode = ({ data, selected, id }) => {
  return (
    <div className="react-flow__node-default" style={{ minWidth: 250, minHeight: 80 }}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ 
          left: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
      
      <div className="condition-label">
        <Typography variant="body2">Random</Typography>
      </div>

      {/* Выходы A и B */}
      <Handle
        type="source"
        position={Position.Right}
        id="A"
        style={{
          right: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
      <Box sx={{ 
        position: 'absolute',
        right: 12,
        top: 24,
        transform: 'translateY(-50%)',
        pointerEvents: 'none'
      }}>
        <Typography variant="caption" color="textSecondary">
          A
        </Typography>
      </Box>

      <Handle
        type="source"
        position={Position.Right}
        id="B"
        style={{
          right: 0,
          top: 44,
          transform: 'translateY(-50%)'
        }}
      />
      <Box sx={{ 
        position: 'absolute',
        right: 12,
        top: 44,
        transform: 'translateY(-50%)',
        pointerEvents: 'none'
      }}>
        <Typography variant="caption" color="textSecondary">
          B
        </Typography>
      </Box>
    </div>
  );
}; 